import React from 'react'
import JobDomain from '../../Profile/ProfileForm/Fields/JobDomain/JobDomain'
import SchoolLevel from '../../Profile/ProfileForm/Fields/SchoolLevel/SchoolLevel'

const JobDomainStep = () => (
  <div>
    <div className="step-content">
      <JobDomain />
      <SchoolLevel />
    </div>
  </div>
)

export default JobDomainStep
